import React from "react";
import {
  Modal,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const CustomScheduleModal = ({
  open,
  onClose,
  customSchedule,
  setCustomSchedule,
  onSave,
}) => {
  
  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div style={{ width: "100%" }}>
          <h3>Create Custom Schedule</h3>

          <TextField
            label="Scheduled Date"
            value={customSchedule.scheduledDate}
            onChange={(e) =>
              setCustomSchedule({
                ...customSchedule,
                scheduledDate: e.target.value,
              })
            }
            fullWidth
            margin="normal"
            type="date"
          />

          <TextField
            label="Order Tag"
            value={customSchedule.orderTag}
            onChange={(e) =>
              setCustomSchedule({ ...customSchedule, orderTag: e.target.value })
            }
            fullWidth
            margin="normal"
          />

          <TextField
            label="Description"
            value={customSchedule.description}
            onChange={(e) =>
              setCustomSchedule({
                ...customSchedule,
                description: e.target.value,
              })
            }
            fullWidth
            margin="normal"
            multiline
            rows={3}
          />

          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={customSchedule.orderStatus || ""}
              onChange={(e) =>
                setCustomSchedule({
                  ...customSchedule,
                  orderStatus: e.target.value,
                })
              }
              style={{ backgroundColor: "white" }}
            >
              <MenuItem value="ready_to_process">Ready to Process</MenuItem>
              <MenuItem value="processing">Processing</MenuItem>
              <MenuItem value="processed">Processed</MenuItem>
              <MenuItem value="delivered">Delivered</MenuItem>
              <MenuItem value="onHold">On Hold</MenuItem>
            </Select>
          </FormControl>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button variant="contained" onClick={onSave}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CustomScheduleModal;
